import React from "react"
import styled from "styled-components"
import Swiper, { Pagination } from "react-id-swiper/lib/ReactIdSwiper.full"
import STYLE_CONSTANTS from "~/style/constants"
import ItemIcon from "./Item/Icon"
import ItemDescription from "./Item/Description"

const Window = styled.div`
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  width: 300px;
  position: relative;
  margin-bottom: 3em;
  ${props => props.theme.media.mobile`
    height: 150px;
    width: 100%;
    margin-bottom: 0;
  `}
`

const ItemContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 45% auto;
  height: 100%;
  width: 275px;
  padding-bottom: 1.5em;
  ${props => props.theme.media.mobile`
    height: 100px;
    margin: 40% auto;
    padding-bottom: 2em;
  `}
`

const TinySliderIconAndText = ({ big, isMobile, items }) => {
  const settings = {
    modules: [Pagination],
    rebuildOnUpdate: true,
    centeredSlides: true,
    preventInteractionOnTransition: true,
    grabCursor: true,
    roundLengths: true, // prevent blurry text
    watchOverflow: true,
    slidesPerView: `1`,
    autoplay: {
      delay: 4000
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    fadeEffect: {
      crossFade: true
    }
  }
  return (
    <Window isMobile={isMobile}>
      <Swiper {...settings}>
        {items.map(({ text, Icon }) => (
          <div key={text}>
            <ItemContainer>
              <ItemIcon>
                <Icon big={big} color={STYLE_CONSTANTS.colors.primary.green} />
              </ItemIcon>
              <ItemDescription big={big}>{text}</ItemDescription>
            </ItemContainer>
          </div>
        ))}
      </Swiper>
    </Window>
  )
}

export default TinySliderIconAndText
